import React, { useEffect } from "react";
import AOS from 'aos';
import "aos/dist/aos.css";

const About = () => {

  useEffect(() => {
    AOS.init({ duration: 1000 });
    AOS.refresh();
  }, []);

  return (
    <div
      className="bg-gradient-to-t from-white via-slate-100 to-white text-gray-700 lg:pl-6"
      name="about"
    >
      <div className="max-w-screen-lg p-9 mb-2 mx-auto flex flex-col justify-center w-full h-auto">
        <div className="pb-2">
          <p className="text-4xl font-logo inline mb-9 border-gray-500" data-aos="fade-down" data-aos-delay="200" data-aos-once="true">
            About 👦🏻
            <svg id="wave" style={{transform: 'rotate(180deg)', transition: '0.3s', width:'8rem'}} viewBox="0 0 1440 100" version="1.1" xmlns="http://www.w3.org/2000/svg"><defs><linearGradient id="sw-gradient-0" x1={0} x2={0} y1={1} y2={0}><stop stopColor="rgba(0, 70, 67, 1)" offset="0%" /><stop stopColor="rgba(0, 30, 29, 1)" offset="100%" /></linearGradient></defs><path style={{transform: 'translate(0, 0px)', opacity: 1}} fill="url(#sw-gradient-0)" d="M0,40L120,33.3C240,27,480,13,720,16.7C960,20,1200,40,1440,53.3C1680,67,1920,73,2160,71.7C2400,70,2640,60,2880,46.7C3120,33,3360,17,3600,13.3C3840,10,4080,20,4320,30C4560,40,4800,50,5040,51.7C5280,53,5520,47,5760,36.7C6000,27,6240,13,6480,10C6720,7,6960,13,7200,26.7C7440,40,7680,60,7920,68.3C8160,77,8400,73,8640,66.7C8880,60,9120,50,9360,48.3C9600,47,9840,53,10080,48.3C10320,43,10560,27,10800,28.3C11040,30,11280,50,11520,58.3C11760,67,12000,63,12240,61.7C12480,60,12720,60,12960,53.3C13200,47,13440,33,13680,30C13920,27,14160,33,14400,35C14640,37,14880,33,15120,30C15360,27,15600,23,15840,25C16080,27,16320,33,16560,30C16800,27,17040,13,17160,6.7L17280,0L17280,100L17160,100C17040,100,16800,100,16560,100C16320,100,16080,100,15840,100C15600,100,15360,100,15120,100C14880,100,14640,100,14400,100C14160,100,13920,100,13680,100C13440,100,13200,100,12960,100C12720,100,12480,100,12240,100C12000,100,11760,100,11520,100C11280,100,11040,100,10800,100C10560,100,10320,100,10080,100C9840,100,9600,100,9360,100C9120,100,8880,100,8640,100C8400,100,8160,100,7920,100C7680,100,7440,100,7200,100C6960,100,6720,100,6480,100C6240,100,6000,100,5760,100C5520,100,5280,100,5040,100C4800,100,4560,100,4320,100C4080,100,3840,100,3600,100C3360,100,3120,100,2880,100C2640,100,2400,100,2160,100C1920,100,1680,100,1440,100C1200,100,960,100,720,100C480,100,240,100,120,100L0,100Z" /></svg>
          </p>
          
        </div>

        <div className="flex">
        <p className="text-xl mt-5" data-aos="fade-up" data-aos-delay="200" data-aos-once="true">
        I am a graduate of Sumatera Institute of Technology with a degree in Informatics Engineering, and have been honing my skills in programming, web development, and design ever since. 
        During my studies, I worked on several projects that helped me develop a strong foundation in coding, as well as a keen eye for interface design and user experience. 
        Since then, I have continued to work on personal projects to further refine my skills and to explore new technologies.
        I am comfortable working with a variety of programming languages and technologies.<br/><br/>
        
        In my free time, I enjoy writing about technology and sharing my knowledge with others through my personal blog. I believe that technology can be a powerful tool for positive change, and my goal is to use my skills to help make a difference in the world. If you have any questions or would like to work with me on a project, please don't hesitate to get in touch!
        </p>


        
        </div>
        
      </div>
    </div>
  );
};

export default About;
